/* eslint-disable */
import { useNavigate } from "react-router-dom";
import { ConfirmAlert } from "../../ConfirmAlert";
import { COMPANYTYPE, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, PRODUCTS, SOCKET_ACTION, SOCKET_EVENTS } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import { useState, useRef, useEffect } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { useTranslation } from "../../locale/useTranslation";
import * as API from "../../framework/API/api"
import { Avatar, Badge } from "@mui/material";
import { GlobalSearchBar } from "../../framework/forms/helpercomponents/inputs/GlobalSearchBarV2";
import socket from "../../framework/socket/socket";
import MyPlansPopup from "./myPlansPopup";
import ChangePasswordForm from "../users/ChangePasswordForm";
import MobileHeader from "../DigitalSign/mobileView/MobileHeader";
import menuModel from "./menuModel";
import UserGuides from "../../components/UserGuides";
import BossDialog from "../../components/BossDialog";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";

const Header = (props) => {

    const navigate = useNavigate();
    const lang = useTranslation();
    const version = utility.getValue(LOCALSTORAGE_KEY.applicationVersion);
    let isDigitalSignage = utility.isAutomateB();
    let isAirSync = utility.isAirSync();
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const notifications = utility.getValue('Notification') ?? [];
    const [notification, setNotification] = useState(utility.getValue('Notification') ?? []);
    const isFirstTimeLogin = utility.getValue(LOCALSTORAGE_KEY.isFirstTimeLogin) ?? false;

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const applicationVersion = utility.getValue(LOCALSTORAGE_KEY.applicationVersion);
    const userLanguage = utility.getValue(LOCALSTORAGE_KEY.USER_LANGUAGE);
    const [isEnterpriseLogin] = useState(company?.CompanyType == COMPANYTYPE.ENTERPRISE);

    const [show, setShow] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showMyPlans, setShowMyPlans] = useState(false);

    const anchor = useRef();
    const isFullScreen = useRef(false);
    const notificationRef = useRef();
    const userMenu = utility.getUserMenu(menuModel(lang, [], user) ?? [])
    const [isMobile, setIsMobile] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isAppInstalled, setIsAppInstalled] = useState(false);
    const [showLanguagePopup, setShowLanguagePopup] = useState(false);
    const [languages, setLanguages] = useState([]);
    const [languageData, setLanguageData] = useState(userLanguage ?? {})

    useEffect(() => {
        loadCombo()
    }, []);

    const loadCombo = async () => {
        let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languagesRes.data);
    }

    const onChangeLanguage = (e) => {
        setLanguageData({ ...languageData, [e.target.name]: e.target.value })
    }

    const handleSubmitLanguage = async () => {
        let finalData = {
            _id: applicationVersion?._id,
            Language: languageData?.Language && Object.keys(languageData?.Language)?.length > 0 ? {
                SID: languageData?.Language?.SID,
                ISOCode: languageData?.Language?.ISOCode,
                Description: languageData?.Language?.Description
            } : {},
        }
        console.log(finalData)
        const res = await API.saveData(ENTITYNAME.ApplicationVersion, finalData);
        if (res.success) {
            utility.setValue(LOCALSTORAGE_KEY.USER_LANGUAGE, finalData.Language);
            useTranslation(finalData.Language);
            setShowLanguagePopup(false);
        } else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }

    useEffect(() => {
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait);
        };
        updateScreenType();
        window.addEventListener('resize', updateScreenType);
        return () => window.removeEventListener('resize', updateScreenType);
    }, []);

    const onClick = () => {
        setShow(!show);
    };


    useEffect(() => {
        // Check if app is already installed (works on iOS and Android)
        const checkAppInstalled = () => {
            const isInstalled =
                (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
                navigator.standalone === true;
            setIsAppInstalled(isInstalled);
        };

        checkAppInstalled();

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', checkAppInstalled); // Detect when app is installed

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', checkAppInstalled);
        };
    }, []);

    const handleAddToHomeScreen = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('User accepted the install prompt');
            } else {
                console.log('User dismissed the install prompt');
            }
            setDeferredPrompt(null);
        }
    };

    const userData = {
        _id: user._id,
        SID: user.SID,
        userName: user.userName,
        name: user.name,
        Email: user.Email,
    }

    const onLogout = () => {

        ConfirmAlert(
            () => {
                navigate('/');
                let logData = { event: LOGEVENT.LOG_OUT, module: MODULE.LOGIN, data: userData, message: LOGEVENT.LOG_OUT };
                API.SaveLogs(logData);
                localStorage.clear();
                sessionStorage.clear();
                socket.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.KILL_USER_SESSION, module: MODULE.ALL, data: userData })
            }, // on Click yes
            () => { }, // on click no
            `${lang.confirm_logout_label}`, //title
            `${lang.are_you_sure_you_want_to_logout}`// message
        )
    }

    const showMyPlansPopup = () => {
        setShowMyPlans(!showMyPlans);
    }

    //socket
    // const socket = useSocket(SOCKET_EVENTS.onSocketNotification, (socketData) => {

    //     let checkRoleInCurrentUser = user.Role.filter((x) => x.SID == socketData.reciever.role.SID).length > 0 ? true : false;

    //     let notifications = utility.getValue('Notification') ?? [];
    //     if(socketData.data.length != 0 && checkRoleInCurrentUser && (socketData.reciever.user.SID == 0 || socketData.reciever.user.SID == user.SID)){
    //         setNotification([{socketData : socketData ,messages : `${socketData.data.length} workorder created`},...notifications])
    //         utility.setValue('Notification',[{socketData : socketData ,messages : `${socketData.data.length} workorder created`},...notifications]);

    //         toast.info(`${socketData.data.length} workorder created`, {
    //           position: toast.POSITION.TOP_RIGHT
    //         });
    //     }

    // });

    const onNotificationClick = () => {
        utility.setValue('DashboardTab', '7');
        navigate('/home')
    }

    const onClickFullScreen = () => {


        if (isFullScreen.current) {

            //need to exit from full screen
            isFullScreen.current = false;

            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
                document.msExitFullscreen();
            }



        } else {
            isFullScreen.current = true;

            console.log('The browser is not in fullscreen mode');
            let elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (anchor.current && !anchor.current.contains(event.target)) {
                setShow(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };
        // Attach the event listener to the body
        document.body.addEventListener('click', handleClickOutside);
        // Clean up the event listener on component unmount
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [show, showNotifications]);


    const steps = [
        {
            target: ".add-to-home",
            content: `
            To enhance your experience, add our app to your home screen. 
            Tap on the "Add to Home Screen" option to quickly access it like a native app.`,
            disableBeacon: true,
        },
    ];


    return (<>
        {isMobile ? <MobileHeader steps={steps} isAppInstalled={isAppInstalled} handleAddToHomeScreen={handleAddToHomeScreen} logo={isDigitalSignage ? require("../../img/AutomateBLogoWhiteOrange.png") : (isAirSync ? require("../../img/AirSyncLogo.png") : require("../../img/BossStudioLogo.png"))} version={version} setShow={setShow} showMyPlansPopup={showMyPlansPopup} isEnterpriseLogin={isEnterpriseLogin} show={show} onLogout={onLogout} setShowChangePassword={setShowChangePassword} onClickProfile={onClick} userMenu={userMenu} user={user} /> :
            <div className={`row ${isAirSync ? 'headerMain-blue' : 'headerMain'}`}>
                <div className={`col ${isDigitalSignage && 'mt-2'}`}>
                    <img src={isDigitalSignage ? require("../../img/AutomateBLogoWhiteOrange.png") : (isAirSync ? require("../../img/AirSyncLogo.png") : require("../../img/BossStudioLogo.png"))} style={{ height: isDigitalSignage ? "22px" : "42px", marginLeft: "15px" }} alt="BMS Group" />
                    {isEnterpriseLogin && <div style={{ color: '#8b8b8d', marginTop: '-7px', marginLeft: "14px", fontSize: "13px", letterSpacing: '05px', fontFamily: "sans-serif" }}>Enterprise</div>}
                </div>

                {/* SEARCH BAR COMPONENT */}

                {/* center */}
                <div style={{ position: 'absolute', left: '35%', marginTop: '-2.5px' }} >
                    <GlobalSearchBar />
                </div>
                {/* <!-- #TOGGLE LAYOUT BUTTONS --> */}

                <div className="pull-right mr-4" >
                    {/* Profile button */}
                    <div className="pull-right">
                        <button className="btn btn-circle btn-md text-uppercase" onClick={onClick} ref={anchor} title="Profile" style={{ backgroundColor: 'white', fontWeight: '800', marginTop: '7px' }}>{user.name.charAt(0)}</button>
                        <Popup anchor={anchor.current} show={show} popupClass={"popup-content"} style={{ width: '20vw', marginTop: '8px' }}>
                            <div className="row m-1 mb-4">
                                <div className="col-12">
                                    <div className="d-flex">
                                        <span>Version - {version?.Version ?? ""}</span>
                                        {utility.isAutomateB() && <a className="ml-auto" href="https://automateb.com/privacy-policy/" target="_blank">{lang.privacy_policy_label}</a>}
                                    </div>

                                    <h3 style={{ fontWeight: '900' }}>{lang.account_label}</h3>
                                    <div className="row">
                                        <div className="col-1"><b className="btn btn-circle btn-md bg-success mt-2 text-uppercase" style={{ color: 'white' }}>{user?.name.charAt(0)}</b></div>
                                        <div className="col ml-3">
                                            <span style={{ fontSize: '16px', fontWeight: '500' }}>{utility.subString(user.name, 25)}</span>
                                            <div>{utility.subString(user?.userName, 22)}</div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div>
                                        <div style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '400' }} onClick={() => { setShowChangePassword(true); setShow(false) }}>{lang.change_password_label}</div>
                                        <hr />
                                        {(utility.isAutomateB() && !isEnterpriseLogin) && <><div style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '400' }} onClick={() => { showMyPlansPopup(); setShow(false) }}>My Plans</div><hr /></>}

                                        <div style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '400' }} onClick={() => { setShowLanguagePopup(true); setShow(false) }}>{lang.language_label}</div>
                                        <hr />

                                        <div style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '400' }} onClick={() => { onLogout(); setShow(false) }}>{lang.log_out_label}</div>
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    </div>

                    {/* Switch Menu Button */}
                    <div title="Switch Menu" id="hide-menu" style={{ color: 'white' }} onClick={props.onMinifyMenuClick} className="pull-right btn-lg btn-circle cursor-pointer">
                        <i className="fa fa-bars"></i>
                    </div>
                    {/* Log Out Button
                    <div id="logout" className="pull-right nav-right-btn" title="Logout" onClick={() => { onLogout(); }}>
                        <span>
                            <a href="# " title="LogOut">
                                <i className="fa fa-right-from-bracket"></i>
                            </a>
                        </span>
                    </div> */}

                    {/* Full Screen Button */}
                    <div title="Full Screen" id="fullscreen" style={{ color: 'white', marginRight: '-15px' }} onClick={onClickFullScreen} className="pull-right btn-lg btn-circle cursor-pointer">
                        <i className="fa fa-arrows-alt"></i>
                    </div>

                    {/* Notifications icon */}
                    <div className="pull-right mt-2 mr-1">
                        <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right' }} badgeContent={notifications.length} color="primary" max={99}>
                            <i className=" fa-solid fa-bell fa-lg" ref={notificationRef} style={{ color: 'white', cursor: 'pointer' }} onClick={() => setShowNotifications(!showNotifications)}></i>
                        </Badge>
                        <Popup anchor={notificationRef.current} show={showNotifications} popupClass={"popup-content"} style={{ width: '20vw', marginTop: '15px' }}>
                            <div className="row m-1 mb-4 ">
                                <div className="notification-box">
                                    <h2 className="notification-header">Notifications <span style={{ color: 'red', margin: '1px' }}>{`(${notification.length})`}</span></h2>
                                    {/* map here */}
                                    {notification.map((obj) => (<div className="notifications-item" onClick={onNotificationClick}>
                                        {/* <img src="https://i.imgur.com/uIgDDDd.jpg" alt="img"/> */}
                                        <div className="notifications-item-avatar"><Avatar>{obj.socketData.user.name.slice(0, 1).toUpperCase()}</Avatar></div>
                                        <div className="text">
                                            <h4>{obj.socketData.user.name}</h4>
                                            <p>{obj.messages}</p>
                                        </div>
                                    </div>))}
                                </div>
                            </div>
                        </Popup>
                    </div>

                    {/* Add to Home Screen Button */}
                    {!isAppInstalled && (<div className="pull-right mr-3 cursor-pointer add-to-home" title="Add to Home screen" style={{ fontSize: '13px', marginTop: '12px' }}>
                        <i className="fa fa-desktop fa-lg" style={{ color: 'white' }} onClick={handleAddToHomeScreen}></i>
                    </div>)}
                </div>
            </div>
        }
        <UserGuides show={isFirstTimeLogin} steps={steps} />
        {showMyPlans && <MyPlansPopup onClose={showMyPlansPopup} />}
        {showChangePassword && <ChangePasswordForm data={user} isClearLocalStorage={true} isRouteHomePage={true} closeForm={() => setShowChangePassword(false)} />}
        {showLanguagePopup &&
            <BossDialog title={lang.language_label} onClose={() => setShowLanguagePopup(false)} width={"400px"}>
                <EditPageHeader onCancel={() => setShowLanguagePopup(false)} onSubmit={handleSubmitLanguage} showTitle={false} />
                <div className="">
                    <label>{lang.language_label}:</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={languages}
                        name="Language"
                        textField="Description"
                        dataItemKey="_id"
                        value={languageData.Language}
                        onChange={onChangeLanguage}
                    />
                </div>
            </BossDialog>}
    </>)
}

export default Header;